// FUNNEL VUEX STORE
import Vuex from 'vuex';
import STATE from './state';
import GETTERS from './getters';
import MUTATIONS from './mutations';
import ACTIONS from './actions';
import {isLocalEnv, isDevelopmentEnv} from '@/js/global/config.js';

export const vuexStore = () => {
   return new Vuex.Store({
      strict: isLocalEnv() || isDevelopmentEnv(),
      state: STATE,
      getters: GETTERS,
      mutations: MUTATIONS,
      actions: ACTIONS,
   });
}